import {Injectable} from '@angular/core';
import {AngularFireDatabase, AngularFireList} from '@angular/fire/database';
import {Observable} from 'rxjs/Rx';
import {Club} from './club';
import {Field} from './field';

@Injectable()
export class ClubsService {
  static clubsPath: string = 'clubs/';


  constructor(private db:AngularFireDatabase) {
  }

  // DONE: upgraded to 5.0
  findAllClubs():Observable<Club[]> {
    return this.db.list('clubs')
      .snapshotChanges()
      .map(actions => {
        return actions.map(action => {
          const $key = action.payload.key;
          return Club.toClub({ $key, ...action.payload.val() });
        })
      })
  }

  findAllClubsForDistributor(code: number):Observable<Club[]> {
    //console.log(`distributorCode: ${code}, type: ${typeof code}`);
    return this.db.list('clubs', ref => ref.orderByChild("distributorCode").equalTo(code))
      .snapshotChanges()
      .map(actions => {
        return actions.map(action => {
          const $key = action.payload.key;
          return Club.toClub({ $key, ...action.payload.val() });
        })
      })
  }

  findClubsByName(name:string): Observable<Club[]> {
    return this.db.list('clubs', ref => ref.startAt(name).endAt(`${name}z`).orderByChild('name'))
      .snapshotChanges().map(actions => {
        return actions.map(action => {
          const $key = action.payload.key;
          return Club.toClub({ $key, ...action.payload.val() });
        })
      });
  }

  findClubsByCity(name:string): Observable<Club[]> {
    //console.log('In findClubsByCity');
    return this.db.list('clubs', ref => ref.startAt(name).endAt(`${name}z`).orderByChild('city'))
      .snapshotChanges().map(actions => {
        return actions.map(action => {
          const $key = action.payload.key;
          return Club.toClub({ $key, ...action.payload.val() });
        })
      });
  }

  findClubById(id:string): Observable<any> {
    return this.db.object('clubs/' + id).snapshotChanges().map(action => {
      const $key = action.payload.key;
      const data = { $key, ...action.payload.val() };
      return data;
    });
    //return this.db.object('clubs' + '/' + id).valueChanges().map(Club.fromJson)
  }

  addClub(name: string, city: string, url: string, distributorCode: string, demo: boolean, latitude: number, longitude: number) {
    let cmd = {
      'name': name,
      'city': city,
      'url': url,
      'distributorCode': distributorCode,
      'demo': demo,
      'latitude': latitude,
      'longitude': longitude
    };

    const newClub = this.db.list(ClubsService.clubsPath);
    let key = newClub.push(cmd);
    //console.log('Club key: ' + key);
  }

}

